import React from 'react';
import TimesheetDateTimeButton from './TimesheetDateTimeButton';
import PhaseCodeManager from './PhaseCodeManager';
import TotalTimeIndicator from './TotalTimeIndicator';

export default class TimesheetTimeAndPhaseCodes extends React.Component {
    render() {
        const { loading, timesheet } = this.props;

        if (loading || !timesheet) {
            return null;
        }

        return (
            <div className="row d-flex mb-2">
                <TimesheetDateTimeButton {...this.props} />

                <PhaseCodeManager {...this.props} />

                <TotalTimeIndicator {...this.props} />
            </div>
        );
    }
}
